let wills,
    dividerCt = 0,
    numPages = 0,
    hash = 1;

const divider = '<div class="bullet-divider"></div>',
      dividerLength = 3,
      poitraitRatio = 600 / 1067,
      willsPerPage = 6;

function isEven(n) { return n % 2 == 0; }

function setWillPage(pg){
    let html = '';
    let initIdx = (pg-1)*willsPerPage;
    let endIdx = initIdx+willsPerPage;
    if(endIdx > wills.length) { endIdx = wills.length; }
    //alert(wills.length);
    //hash = location.hash;
    //alert(parseInt(hash.replace('#', ''))+1);
    html += '<div class="will-image-holder">';

    for(i=initIdx; i<endIdx; i++){

           dividerCt ++;

           if (dividerCt > dividerLength) {
               dividerCt = 0;
               html += divider;
           }

           html += '<div class="link-wrap ';
           if( isEven(dividerCt) ) { html += 'right'; }
           html += '"><a href="#" class="'+ wills[i].color +'" data-id="' + wills[i].id + '" data-color="' + wills[i].color + '" title="">';
           html += '<span>'+ wills[i].name +'</span><img src="/page/'+ wills[i].id +'/'+ wills[i].color ;
           if( isEven(dividerCt) ) { html += '-p'; }
           html += '.png" alt="" /><span class="zoomin-label"></span></a></div>';
           //alert(i);


    }
    html += '<br class="clear" />';
    html += '</div>';

    if(wills.length > willsPerPage){
        html += '<div class="padination">';
        numPages = Math.ceil(wills.length/willsPerPage);
        for(i=0; i<numPages; i++){
            html += '<a href="#'+ (i+1) +'"';
            if((i+1) == pg){
                html += ' class="active"';
            }
            html += '>'+(i+1)+'</a>';
        }
        html += '</div>';
    }


    document.getElementById('mylastwill-image-gallery').innerHTML = html;

    let galLinks = document.querySelectorAll('#mylastwill-image-gallery .will-image-holder a');
    for(i=0; i<galLinks.length; i++){
        galLinks[i].addEventListener('click',function(e){
            let isPortrait = false;
            let imgSrc = '/page/' + this.getAttribute('data-id') +'/' + this.getAttribute('data-color');
            if(winW < winH) {
                imgSrc += '-p';
                isPortrait = true;
            }
            imgSrc += '.png'

            let h = Math.round(winH * 0.8);
            let w = (isPortrait) ? Math.round(h * poitraitRatio) : h;

            document.getElementById('modal-content').innerHTML = '<img src="'+ imgSrc +'" width="'+ w +'" height="'+ h +'" alt="" />';

            const imgNode = document.querySelector('#modal-content img');

            const mL = Math.round((winW - w)*0.5);
            const mT = Math.round((winH - h)*0.5);

            imgNode.style.marginLeft = mL + 'px';
            imgNode.style.marginTop = mT + 'px';

            document.getElementById('modal-close').style.right = mL + 'px';
            document.getElementById('modal-close').style.top = (mT - 50) + 'px';
            //imgNode.setAttribut
            //document.getElementById('modal-content').innerHTML = '<img src="'+ imgSrc +'" alt="" />';

            //alert();

            document.body.classList.add('page-modal');
            e.preventDefault();
        });
    }

    let pageLinks = document.querySelectorAll('#mylastwill-image-gallery .padination a');
    for(i=0; i<pageLinks.length; i++){
        pageLinks[i].addEventListener('click',function(e){
            if(this.classList.contains('active') == false){
                const hs = this.getAttribute('href');
                hash = parseInt(hs.replace('#', ''));

                document.getElementById('mylastwill-image-gallery').scrollIntoView({ behavior: "smooth", inline: "start" });
                setTimeout(function(){
                    location.hash = '#'+hash;
                    setWillPage(hash);
                }, 600);
            }
            e.preventDefault();
        });
    }

}


function createWillGallery(){
    if( document.getElementById('mylastwill-image-gallery') ){

        const request = new XMLHttpRequest();
        request.open('GET', '/_assets/data/wills.json');
        request.onreadystatechange = function() {
            if(this.readyState === 4 && this.status === 200) {
                wills = JSON.parse(this.responseText).wills;
                if(location.hash){
                    const lh = location.hash;
                    hash = parseInt(lh.replace('#', ''));
                }
                setWillPage(hash);

            }
        };
        request.send();

        if( document.getElementById('filter-by') ) {
            document.getElementById('filter-wills').addEventListener('click',function(e){
                if(this.className != 'active'){
                    document.getElementById('filter-videos').className = '';
                    document.getElementById('mylastwill-image-gallery').className = 'active';
                    document.getElementById('mylastwill-video-gallery').className = 'inactive';

                    this.className = 'active';
                }
                e.preventDefault();
            });
            document.getElementById('filter-videos').addEventListener('click',function(e){
                if(this.className != 'active'){
                    document.getElementById('filter-wills').className = '';
                    document.getElementById('mylastwill-image-gallery').className = 'inactive';
                    document.getElementById('mylastwill-video-gallery').className = 'active';

                    this.className = 'active';
                }
                e.preventDefault();
            });
        }
    }
}
